<template>
  <div
    :class="[
      'dashboard',
      {
        'logged-in': !isMobile,
        'not-logged-in': isMobile,
        collapsed: this.$root.isCollapsed && !isMobile,
        notification:
          this.$root.warning && this.$root.warning !== 'NORMAL' && !isMobile,
      },
    ]"
  >
    <div class="frame-35732">
      <div class="frame-35733">
        <div
          class="tab-1"
          :style="
            tab === 'myaccount'
              ? 'box-shadow: 0px -4px 24px 0px #8FC8FF; background: white;'
              : 'box-shadow: -4px -4px 8px 0px #fff, 4px 4px 8px 0px rgba(0, 0, 0, 0.25); background: #E0F5FF;'
          "
          @click="updateQueryTab('myaccount')"
        >
          {{$t("my-account")}}
        </div>
        <div
          class="tab-1"
          v-if="userDetails?.includes('TEAMS')"
          :style="
            tab === 'teams'
              ? 'box-shadow: 0px -4px 24px 0px #8FC8FF; background: white;'
              : 'box-shadow: -4px -4px 8px 0px #fff, 4px 4px 8px 0px rgba(0, 0, 0, 0.25); background: #E0F5FF;'
          "
          @click="updateQueryTab('teams')"
        >
          {{$t("teams")}}
        </div>
        <div
          class="tab-1"
          v-if="userDetails?.includes('CREDIT_MANAGEMENT')"
          :style="
            tab === 'credits'
              ? 'box-shadow: 0px -4px 24px 0px #8FC8FF; background: white;'
              : 'box-shadow: -4px -4px 8px 0px #fff, 4px 4px 8px 0px rgba(0, 0, 0, 0.25); background: #E0F5FF;'
          "
          @click="updateQueryTab('credits')"
        >
          {{$t("credits")}}
        </div>
      </div>
      <div class="frame-35734" v-if="tab === 'myaccount'">
        <div class="frame-357341" style="border-bottom: none">
          <div class="frame-35735">{{$t("account-details")}}</div>
          <div class="frame-357351">
            <div class="cancel-button" v-if="!isEditing" @click="toggleEdit">
              {{$t("edit")}}
            </div>
            <div
              class="save-button"
              v-if="isEditing && hasChanges"
              @click="saveChanges"
            >
              Save
            </div>
            <div
              class="cancel-button"
              v-if="isEditing"
              @click="confirmCancelEdit"
            >
              {{$t("cancel")}}
            </div>
          </div>
        </div>
        <div class="info">
          <div
            class="profile-info-wrapper"
            :style="{
              width: isEntity ? '65%' : '100%',
              borderTop: '2px solid #cccccc',
            }"
          >
            <div class="frame-35736">
              <div class="frame-35737">
                <div class="title">{{$t("user-name")}}</div>
                <div class="value" v-if="!isEditing">{{ originalUser }}</div>
                <input
                  v-else
                  type="text"
                  :placeholder="
                    originalUser && originalUser !== ''
                      ? originalUser
                      : $t('enter-name')
                  "
                  class="user-name-input"
                  autocomplete="off"
                  id="username"
                  v-model="user"
                  @input="checkChanges"
                />
              </div>
            </div>
            <div class="frame-35736">
              <div class="frame-35737">
                <div class="title">{{$t("email-address")}}</div>
                <div class="value">{{ email }}</div>
              </div>
            </div>
            <div class="frame-35736">
              <div class="frame-35737">
                <div class="title">{{$t("mobile-number")}}</div>
                <div class="value" v-if="!isEditing">
                  {{
                    phoneWithCountryCode && phoneWithCountryCode !== ""
                      ? phoneWithCountryCode
                      : "-"
                  }}
                </div>
                <div class="input-group-phone" v-else>
                  <select
                    v-model="selectedCountryCode"
                    class="country-dropdown"
                    @change="checkChanges"
                  >
                    <option value="" disabled>{{$t("select-country")}}</option>
                    <option
                      v-for="country in countries"
                      :value="country"
                      :key="country.code"
                      class="country-option"
                    >
                      {{ country.name }} - (+{{
                        getFirstDialCode(country.dialCode)
                      }})
                    </option>
                  </select>
                  <input
                    class="phone-input"
                    type="tel"
                    v-model="phone"
                    :placeholder="
                      phone && phone !== '' ? formattedphone : $t('phone')
                    "
                    inputmode="numeric"
                    autocomplete="tel"
                    required
                    pattern="[0-9]*"
                    @input="
                      phone = phone.replace(/\D/g, '');
                      checkChanges();
                    "
                  />
                </div>
              </div>
            </div>
            <div class="frame-35736" v-if="isEntity">
              <div class="frame-35737">
                <div class="title">{{$t("branch")}}</div>
                <div class="value" v-if="!isEditing">
                  {{ currentBranchName }}
                </div>
                <select
                  v-else
                  v-model="branchName"
                  class="user-name-input"
                  style="padding: 0 15px"
                  @change="checkChanges"
                >
                  <option value="" disabled>
                    {{
                      branches !== null
                        ? $t('select-branch')
                        : $t('no-branch')
                    }}
                  </option>
                  <option
                    v-for="branch in branches"
                    :value="branch.id"
                    :key="branch.id"
                    class="country-option"
                  >
                    {{ branch.branchName }}
                  </option>
                </select>
              </div>
            </div>
            <div class="frame-35736" style="border: none">
              <div
                class="frame-35737"
                style="cursor: pointer; display: flex; flex-direction: row"
                @click="togglePasswordChange"
              >
                <i class="fa-solid fa-key" style="color: #224096"></i>
                <div
                  class="value"
                  style="text-decoration: underline; font-weight: 600"
                >
                  {{$t("change-password")}}
                </div>
              </div>
            </div>
          </div>
          <div
            class="poc-details"
            v-if="rmDetails || userDetails?.includes('REWARDS')"
          >
            <div class="poc-title" v-if="rmDetails">{{$t("point-of-contact")}}</div>
            <div class="poc-data" v-if="rmDetails">
              <div class="label">{{$t('name')}}</div>
              <div class="value">{{ pocName || "N/A" }}</div>
            </div>
            <div class="poc-data" v-if="rmDetails">
              <div class="label">{{$t("email")}}</div>
              <div class="value">{{ pocEmail || "N/A" }}</div>
            </div>
            <div class="poc-data" v-if="rmDetails">
              <div class="label">{{$t("mobile-no")}}</div>
              <div class="value">{{ pocPhone || "N/A" }}</div>
            </div>
            <div class="referal-card" v-if="userDetails?.includes('REWARDS')">
              <div class="card-title-wrapper">
                <div class="card-title">
                  {{$t("earn")}} {{ this.$root.referralCredits }} {{ $t("invite-friend") }}
                </div>
                <div class="card-title-2">
                  {{$t("join-team")}}
                  {{ this.$root.referralCredits }}
                  {{$t("place-order")}}
                </div>
                <div class="referal-code-box">
                  <div class="referal-code">{{ referralCode }}</div>
                </div>
                <div class="invite-button" @click="toggleInviteNewUser">
                  {{$t("invite")}}
                </div>
                <div class="card-title-2" style="margin-top: 10px">
                  {{$t("share-via")}}
                </div>
                <div class="tooltip-content-profile">
                  <div
                    v-for="(option, index) in this.shareOptions"
                    :key="index"
                    :title="`Share referral link on ${option.label}`"
                    class="tooltip-message-profile"
                    @click="this.handleShare(option.type)"
                  >
                    <img
                      :src="this.$root.getCDNlink(option.icon)"
                      :alt="`Share referral link on ${option.label} - Credencedata`"
                      class="social-media-icons"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Teams  -->
      <div class="frame-35734" v-if="!viewTeam && tab === 'teams'">
        <div class="frame-357341">
          <div class="frame-35735">{{$t('teams')}}</div>
          <div class="frame-357351">
            <div
              class="save-button"
              id="create-team-button"
              style="flex: none; gap: 8px"
              @click="createTeam"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="team-icon"
              >
                <g id="Icons">
                  <path
                    id="Vector"
                    d="M14.8924 18.9862C16.0004 18.2729 16.8416 17.2338 17.2916 16.0225C17.7416 14.8111 17.7765 13.4919 17.3912 12.2599C17.0059 11.0279 16.2208 9.94854 15.152 9.18138C14.0832 8.41421 12.7875 8 11.4564 8C10.1253 8 8.8296 8.41421 7.76081 9.18138C6.69202 9.94854 5.90691 11.0279 5.5216 12.2599C5.13628 13.4919 5.17121 14.8111 5.62122 16.0225C6.07123 17.2338 6.91243 18.2729 8.02042 18.9862C6.01617 19.7005 4.3045 21.0223 3.1408 22.7543C3.07964 22.8422 3.03716 22.941 3.01583 23.0449C2.99449 23.1488 2.99473 23.2558 3.01653 23.3596C3.03833 23.4635 3.08125 23.5621 3.1428 23.6497C3.20435 23.7374 3.28331 23.8123 3.37507 23.8702C3.46684 23.928 3.56958 23.9677 3.67734 23.9868C3.7851 24.006 3.89571 24.0042 4.00276 23.9817C4.10981 23.9591 4.21115 23.9162 4.30089 23.8554C4.39064 23.7947 4.467 23.7172 4.52553 23.6277C5.27617 22.5113 6.30331 21.5939 7.51369 20.9589C8.72407 20.3238 10.0793 19.9912 11.4564 19.9912C12.8335 19.9912 14.1888 20.3238 15.3991 20.9589C16.6095 21.5939 17.6367 22.5113 18.3873 23.6277C18.5086 23.802 18.6959 23.9231 18.9087 23.9649C19.1216 24.0066 19.3429 23.9657 19.5248 23.851C19.7068 23.7363 19.8347 23.5569 19.8809 23.3517C19.9272 23.1465 19.8881 22.9319 19.772 22.7543C18.6083 21.0223 16.8967 19.7005 14.8924 18.9862ZM6.90954 13.9979C6.90954 13.1283 7.17621 12.2783 7.67583 11.5553C8.17544 10.8322 8.88557 10.2687 9.7164 9.93591C10.5472 9.60313 11.4615 9.51607 12.3435 9.68571C13.2255 9.85536 14.0356 10.2741 14.6715 10.889C15.3074 11.5039 15.7405 12.2873 15.9159 13.1402C16.0914 13.9931 16.0013 14.8771 15.6572 15.6805C15.313 16.4839 14.7303 17.1705 13.9825 17.6536C13.2348 18.1368 12.3557 18.3946 11.4564 18.3946C10.2509 18.3933 9.09521 17.9297 8.2428 17.1054C7.39039 16.2811 6.91091 15.1636 6.90954 13.9979ZM28.625 23.8605C28.4414 23.9763 28.2177 24.0168 28.0032 23.9732C27.7886 23.9295 27.6008 23.8052 27.481 23.6277C26.7313 22.5106 25.7043 21.5929 24.4937 20.9581C23.283 20.3233 21.9273 19.9916 20.5502 19.9934C20.3309 19.9934 20.1206 19.9092 19.9656 19.7593C19.8106 19.6094 19.7235 19.406 19.7235 19.194C19.7235 18.982 19.8106 18.7787 19.9656 18.6288C20.1206 18.4788 20.3309 18.3946 20.5502 18.3946C21.2198 18.394 21.881 18.2504 22.4865 17.9741C23.0921 17.6977 23.627 17.2954 24.0531 16.796C24.4793 16.2966 24.7861 15.7123 24.9516 15.0849C25.1171 14.4575 25.1373 13.8025 25.0107 13.1667C24.8842 12.5309 24.6139 11.93 24.2193 11.4069C23.8247 10.8838 23.3155 10.4514 22.728 10.1407C22.1406 9.82992 21.4894 9.64847 20.821 9.60929C20.1527 9.57011 19.4836 9.67415 18.8616 9.914C18.7602 9.95639 18.651 9.97869 18.5406 9.9796C18.4301 9.9805 18.3205 9.95998 18.2184 9.91925C18.1163 9.87853 18.0236 9.81842 17.9459 9.74248C17.8682 9.66653 17.807 9.5763 17.766 9.47711C17.725 9.37792 17.7049 9.27179 17.707 9.16498C17.7091 9.05817 17.7334 8.95285 17.7783 8.85524C17.8232 8.75764 17.8879 8.66973 17.9685 8.59671C18.0492 8.52369 18.1441 8.46704 18.2478 8.43011C19.6712 7.88117 21.2545 7.86142 22.6921 8.37466C24.1297 8.8879 25.3198 9.89776 26.0329 11.2094C26.7459 12.5211 26.9313 14.0417 26.5534 15.4777C26.1754 16.9138 25.2609 18.1637 23.9862 18.9862C25.9904 19.7005 27.7021 21.0223 28.8658 22.7543C28.9855 22.9319 29.0274 23.1482 28.9823 23.3556C28.9371 23.5631 28.8086 23.7447 28.625 23.8605Z"
                    fill="white"
                  />
                </g>
              </svg>
              <span>{{$t("create-team")}}</span>
            </div>
          </div>
        </div>
        <div class="table-wrapper">
          <table id="searchResultTable" v-if="teams && teams.length > 0">
            <thead style="background: #E0F5FF">
              <tr>
                <th v-for="col in teamTableColumns" :key="col">
                  {{ col }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(teamDetails, index) in teams"
                :style="hoveredRow2 === index ? hoverStyle : {}"
                :key="index"
              >
                <td style="text-transform: capitalize">
                  {{ teamDetails?.name?.toLowerCase() }}
                </td>
                <td>
                  {{ teamDetails?.member_count }}
                </td>
                <td class="action-buttons">
                  <div
                    class="view-team"
                    title="View Team Detais"
                    @click="viewTeamMembers(teamDetails)"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22 12C22 12 19 18 12 18C5 18 2 12 2 12C2 12 5 6 12 6C19 6 22 12 22 12Z"
                        stroke="#224096"
                        stroke-linecap="round"
                      />
                      <circle
                        cx="12"
                        cy="12"
                        r="3"
                        stroke="#224096"
                        stroke-linecap="round"
                      />
                    </svg>
                    {{$t("view-team")}}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="no-teams-wrapper" v-else>
            <TeamAnimation />
            <div class="no-teams">
             {{$t("no-team")}}<br />{{$t("start-creating-team")}}
            </div>
          </div>
        </div>
      </div>
      <!-- Team members -->
      <div class="frame-35734" v-if="viewTeam && tab === 'teams'">
        <div class="frame-357341">
          <div class="frame-35735-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              style="cursor: pointer"
              @click="showTeamListTable"
            >
              <path
                d="M3.21986 12.5307L9.96986 19.2807C10.1106 19.4214 10.3015 19.5005 10.5005 19.5005C10.6995 19.5005 10.8904 19.4214 11.0311 19.2807C11.1718 19.1399 11.2509 18.9491 11.2509 18.7501C11.2509 18.551 11.1718 18.3602 11.0311 18.2194L5.5608 12.7501H20.2505C20.4494 12.7501 20.6402 12.671 20.7808 12.5304C20.9215 12.3897 21.0005 12.199 21.0005 12.0001C21.0005 11.8011 20.9215 11.6104 20.7808 11.4697C20.6402 11.3291 20.4494 11.2501 20.2505 11.2501H5.5608L11.0311 5.78068C11.1718 5.63995 11.2509 5.44907 11.2509 5.25005C11.2509 5.05103 11.1718 4.86016 11.0311 4.71943C10.8904 4.5787 10.6995 4.49963 10.5005 4.49963C10.3015 4.49963 10.1106 4.5787 9.96986 4.71943L3.21986 11.4694C3.15013 11.5391 3.09481 11.6218 3.05707 11.7128C3.01933 11.8039 2.9999 11.9015 2.9999 12.0001C2.9999 12.0986 3.01933 12.1962 3.05707 12.2873C3.09481 12.3783 3.15013 12.461 3.21986 12.5307Z"
                fill="#224096"
              />
            </svg>
            <span>{{ selectedTeam?.name?.toLowerCase() }}</span>
          </div>
          <div class="frame-357351">
            <div
              class="cancel-button"
              style="flex: none; gap: 8px"
              @click="inviteMembersModal()"
            >
              <span>{{$t("invite-members")}}</span>
            </div>
          </div>
        </div>

        <div
          class="table-wrapper"
          v-if="teamMembers && teamMembers?.length !== 0"
        >
          <table
            id="searchResultTable"
            v-if="!mobile && teamMembers && teamMembers?.length > 0"
          >
            <thead style="background: #E0F5FF">
              <tr>
                <th v-for="col in teamMembersTableColumns" :key="col">
                  {{ col }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(memberDetails, index) in teamMembers"
                :style="hoveredRow2 === index ? hoverStyle : {}"
                :key="index"
              >
                <td style="text-transform: capitalize">
                  {{ memberDetails?.name?.toLowerCase() }}
                </td>
                <td>
                  {{ memberDetails?.email }}
                </td>
                <td>
                  {{ memberDetails?.designationName }}
                </td>
                <td>
                  <span
                    class="status-bg"
                    :style="{
                      background:
                        memberDetails?.is_verified === 0
                          ? '#FFF697'
                          : memberDetails?.is_verified === 2
                          ? '#E2EAF5'
                          : '#91EBAA',
                      color:
                        memberDetails?.is_verified === 0
                          ? '#3C3708'
                          : memberDetails?.is_verified === 2
                          ? '#000000'
                          : '#054015',
                    }"
                    >{{
                      memberDetails?.is_verified === 0
                        ? $t("not-verified")
                        : memberDetails?.is_verified === 2
                        ? $t("invited")
                        : $t("verified")
                    }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <div
            id="searchResultDiv"
            v-if="mobile && teamMembers && teamMembers?.length > 0"
          >
            <div
              v-for="(memberDetails, index) in teamMembers"
              :key="index"
              class="result-wrapper"
            >
              <div class="row">
                <div class="label">{{$t("name")}}:</div>
                <div class="value">
                  {{ memberDetails?.name?.toLowerCase() }}
                </div>
              </div>
              <div class="row">
                <div class="label">{{$t("email")}}:</div>
                <div class="value" style="text-transform: none">
                  {{ memberDetails?.email }}
                </div>
              </div>
              <div class="row">
                <div class="label">{{$t("role")}}:</div>
                <div class="value">
                  {{ memberDetails?.designationName }}
                </div>
              </div>
              <div class="row">
                <div class="label">{{$t("status")}}:</div>
                <div class="value">
                  <span
                    class="status-bg"
                    :style="{
                      background:
                        memberDetails?.is_verified === 0
                          ? '#FFF697'
                          : memberDetails?.is_verified === 2
                          ? '#E2EAF5'
                          : '#91EBAA',
                      color:
                        memberDetails?.is_verified === 0
                          ? '#3C3708'
                          : memberDetails?.is_verified === 2
                          ? '#000000'
                          : '#054015',
                    }"
                    >{{
                       memberDetails?.is_verified === 0?
                      $t("not-verified")
                        : memberDetails?.is_verified === 2
                        ? $t("invited")
                        : $t("verified")
                      
                    }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Credits -->
      <Credits
        v-if="tab === 'credits'"
        @toggleLoader="toggleLoader()"
        @disableLoader="disableLoader()"
      />
    </div>
    <CreateTeamModal
      v-if="showCreateTeamModal"
      :hideCreateTeamModal="hideCreateTeamModal"
      :inviteMembersModal="inviteMembersModal"
    />
    <InviteMembersModal
      v-if="showInviteMembersModal"
      :hideInviteMembersModal="hideInviteMembersModal"
      :showInvitationStatusModal="showInvitationStatusModal"
      :newTeam="viewTeam ? false : true"
    />
    <InvitationStatus
      v-if="showInvitationStatus"
      :invitations="invitations"
      @close="hideInvitationStatus()"
    />
    <InviteNewUser v-if="showInviteNewUser" @close="toggleInviteNewUser()" />
    <ChangePasswordModal
      v-if="showPasswordChangeModal"
      :email="email"
      @showStatus="passwordChangeStatus"
      @close="cancelPasswordChange"
    />
    <PasswordChangeStatus
      v-if="showPasswordChangeStatus"
      @close="closePasswordChangeStatus"
    />
  </div>
  <div class="loader-wrapper" v-if="isLoading">
    <LoaderAnimation />
    {{$t("please-wait")}}
  </div>
  <Toastify ref="toastContainer" />
</template>
<script>
import VueCookies from "vue-cookies";
import {
  AllCountries,
  UpdateUserDetails,
  GetTeamList,
  GetTeamMembersList,
  GetBranchList,
} from "@/api/APIs";
import CreateTeamModal from "@/views/Modals/CreateTeamModal.vue";
import InviteMembersModal from "@/views/Modals/InviteMembersModal.vue";
import InvitationStatus from "@/views/Modals/InvitationStatus.vue";
import Toastify from "@/components/Toastify.vue";
import InviteNewUser from "@/views/Modals/InviteNewUser.vue";
import TeamAnimation from "@/assets/Animation/AddTeamMembers/AddTeamMembers.vue";
import "floating-vue/dist/style.css";
import Credits from "@/components/Credits.vue";
import { mapGetters } from "vuex";
import ChangePasswordModal from "@/views/Modals/PasswordChange.vue";
import PasswordChangeStatus from "@/views/Modals/PasswordChangeStatus.vue";
import LoaderAnimation from "@/assets/Animation/LoaderAnimation.vue";

export default {
  name: "UserProfile",
  components: {
    CreateTeamModal,
    InviteMembersModal,
    InvitationStatus,
    Toastify,
    InviteNewUser,
    TeamAnimation,
    Credits,
    ChangePasswordModal,
    PasswordChangeStatus,
    LoaderAnimation,
  },
  props: {},
  data() {
    return {
      tab: null,
      isLoading: false,
      user: VueCookies.get("user"),
      originalUser: VueCookies.get("user"),
      email: VueCookies.get("email"),
      userType: VueCookies.get("user-type"),
      countries: [],
      prevSelectedCountry: {},
      selectedCountryCode: {
        id: 97,
        name: "India",
        code: "IN",
        dialCode: "91",
        phoneLength: "10",
        flagEmoji: "??",
        flagImage:
          "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg",
        productOptions: {
          REPORT_COMPREHENSIVE: {
            NO_UPDATE: {
              eta_hours: 1,
              purchase_credits: 50,
              purchase_usd: 50,
            },
            UPDATED: {
              eta_hours: 2.5,
              purchase_credits: 76,
              purchase_usd: 76,
            },
            FRESH: {
              eta_hours: 5,
              purchase_credits: 150,
              purchase_usd: 150,
            },
          },
        },
        searchNotes: {
          REPORT_COMPREHENSIVE:this.$t('rule_description')
        },
        stackOrder: 4,
      },
      // teamTableColumns: ["Team Name", "No. of Members", "Action"],
      // teamMembersTableColumns: ["Name", "Email", "Role", "Status"],
      teams: null,
      showCreateTeamModal: false,
      showInviteMembersModal: false,
      showInvitationStatus: false,
      phone: VueCookies.get("phone") ? VueCookies.get("phone") : "",
      originalPhone: VueCookies.get("phone") ? VueCookies.get("phone") : "",
      phoneWithCountryCode: VueCookies.get("phone_w_countryCode")
        ? VueCookies.get("phone_w_countryCode")
        : VueCookies.get("phone"),
      isEditing: false,
      hasChanges: false,
      isMobile: window.innerWidth < 1023,
      mobile: window.innerWidth <= 767,
      viewTeam: false,
      selectedTeam: null,
      teamMembers: null,
      pocName: VueCookies.get("RM")?.name,
      pocEmail: VueCookies.get("RM")?.email,
      pocPhone: VueCookies.get("RM")?.phone,
      showPasswordChangeModal: false,
      showPasswordChangeStatus: false,
      invitations: null,
      branchName: VueCookies.get("branch") ? VueCookies.get("branch") : "",
      originalBranchName: VueCookies.get("branch")
        ? VueCookies.get("branch")
        : "",
      branches: [],
      showInviteNewUser: false,
      isTooltipOpen: false,
      shareOptions: [
        {
          type: "link",
          label: "Share Link",
          icon: "assets/SocialMediaIcons/link.webp",
        },
        {
          type: "whatsapp",
          label: "Whatsapp",
          icon: "assets/SocialMediaIcons/whatsapp.webp",
        },
        {
          type: "linkedin",
          label: "LinkedIn",
          icon: "assets/SocialMediaIcons/linkedin.webp",
        },
        {
          type: "twitter",
          label: "Twitter",
          icon: "assets/SocialMediaIcons/x.webp",
        },
      ],
    };
  },
  watch: {
    "$route.query.tab": {
      immediate: true,
      handler(newTab) {
        this.tab = newTab;
      },
    },
  },
  created() {
    this.tab = this.$route.query.tab;
  },
  mounted() {
    this.fetchCountryList();
    window.addEventListener("resize", this.handleResponsive);
    if (VueCookies.get("entityId")) {
      this.TeamList();
      this.GetAllBranchList();
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResponsive);
    this.viewTeam = false;
  },
  computed: {
    teamTableColumns(){
      return [
      this.$t("team-name"),
      this.$t("no-of-member"),
      this.$t("action"),
    ]
  },
  teamMembersTableColumns(){
   return [
   this.$t("name"),
   this.$t("email"),
   this.$t("role"),
   this.$t("status")
  ]
  },
    ...mapGetters(["userDetails"]),
    referralCode() {
      return this.$store.getters.referralCode;
    },
    rmDetails() {
      return VueCookies.get("RM");
    },
    isRetailUser() {
      return ["RETAIL"].includes(this.userType);
    },
    isEntity() {
      return VueCookies.get("entityId");
    },
    currentBranchName() {
      const branch = this.branches?.find(
        (branch) => branch.id === Number(this.originalBranchName)
      );
      return branch ? branch.branchName : "-";
    },
  },
  methods: {
    toggleLoader() {
      this.isLoading = true;
    },
    disableLoader() {
      this.isLoading = false;
    },
    togglePasswordChange() {
      this.showPasswordChangeModal = !this.showPasswordChangeModal;
    },
    passwordChangeStatus() {
      this.showPasswordChangeModal = false;
      this.showPasswordChangeStatus = !this.showPasswordChangeStatus;
    },
    closePasswordChangeStatus() {
      this.showPasswordChangeStatus = false;
    },
    cancelPasswordChange() {
      this.showPasswordChangeModal = false;
    },
    removeCountryCode(phone) {
      return phone.split("-").pop();
    },
    formattedphone(event) {
      if (event) {
        this.phone = this.removeCountryCode(event.target.value);
      } else {
        this.phone = this.removeCountryCode(this.phone);
      }
    },
    toggleTooltip() {
      this.isTooltipOpen = !this.isTooltipOpen;
    },
    handleShare(type) {
      this.toggleTooltip();
      const baseUrl = window.location.origin;
      const referralMessage=`${this.$t("referal-message-1")} ${this.referralCode}, 
      ${this.$t("referal-message-2")} ${this.referralCredits} ${this.$t("referal-message-3")} :) ${this.$t("referal-message-4")} 
      ${baseUrl}/login?type=SignUp&refCode=${this.referralCode}`
      const referralLink = `${baseUrl}/login?type=SignUp&refCode=${this.referralCode}`;
      if (type === "link") {
        this.copyToClipboard(true);
      } else {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        let shareUrl;
        switch (type) {
          case "whatsapp":
            shareUrl = `https://wa.me/?text=${encodeURIComponent(
              referralMessage
            )}`;
            break;
          case "linkedin":
            shareUrl = `https://www.linkedin.com/sharing/share-offsite/?text=${encodeURIComponent(
              referralMessage
            )}`;
            break;
          // case "facebook":
          //   shareUrl = `https://www.facebook.com/dialog/sharer?display=popup&quote=${encodeURIComponent(
          //     referralMessage
          //   )}`;
          //   break;
          case "twitter":
            shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
              referralMessage
            )}`;
            break;
        }

        if (isMobile) {
          const appUrl = this.getAppUrl(type, referralMessage, referralLink);
          window.location.href = appUrl;
          setTimeout(() => {
            window.location.href = shareUrl;
          }, 1000);
        } else {
          window.open(shareUrl, "_blank");
        }
      }
    },
    getAppUrl(type, referralMessage) {
      switch (type) {
        case "whatsapp":
          return `whatsapp://send?text=${encodeURIComponent(referralMessage)}`;
        case "linkedin":
          return `linkedin://shareArticle?mini=true&text=${encodeURIComponent(
            referralMessage
          )}`;
        case "email":
          return `mailto:?subject=Join me on CredenceData&body=${encodeURIComponent(
            referralMessage
          )}`;
        // case "facebook":
        //   return `fb://faceweb/f?href=${encodeURIComponent(referralMessage)}`;
        case "twitter":
          return `twitter://post?message=${encodeURIComponent(
            referralMessage
          )}`;
        default:
          return "";
      }
    },
    toggleInviteNewUser() {
      this.showInviteNewUser = !this.showInviteNewUser;
    },
    copyToClipboard(message) {
      const baseUrl = window.location.origin;
      const referralMessage=`${this.$t("referal-message-1")} ${this.referralCode}, 
      ${this.$t("referal-message-2")} ${this.referralCredits} ${this.$t("referal-message-3")} :) ${this.$t("referal-message-4")} 
      ${baseUrl}/login?type=SignUp&refCode=${this.referralCode}`
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(message ? referralMessage : this.referralCode)
          .then(() => {
            alert(
              message
                ? this.$t('copied-clipboard')
                : this.$t('referal-code-copied')
            );
          })
          .catch((err) => {
            console.error("Failed to copy: ", err);
          });
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = message ? referralMessage : this.referralCode;
        textarea.style.position = "fixed";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand("copy");
          alert(
            message
              ? this.$t('copied-clipboard')
              : this.$t('referal-code-copied')
          );
        } catch (err) {
          console.error("Fallback: Oops, unable to copy", err);
        }
        document.body.removeChild(textarea);
      }
    },
    async GetAllBranchList() {
      try {
        const response = await GetBranchList(VueCookies.get("entityId"));
        if (response.message === "SUCCESS") {
          this.branches = response?.allBranches;
        } else {
          this.branches = null;
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    async TeamList() {
      try {
        let payload = {
          userId: VueCookies.get("id"),
        };
        const response = await GetTeamList(payload);
        if (response) {
          this.teams = response;
        } else {
          return this.$refs.toastContainer.addToast(response.message, {
            type: "error",
          });
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    async viewTeamMembers(teamDetails) {
      VueCookies.set("teamName", teamDetails?.name);
      VueCookies.set("teamID", teamDetails?.id);
      this.selectedTeam = teamDetails;
      try {
        let payload = {
          teamId: teamDetails.id,
        };
        const response = await GetTeamMembersList(payload);
        if (response) {
          this.viewTeam = true;
          this.teamMembers = response;
        } else {
          return this.$refs.toastContainer.addToast(response.message, {
            type: "error",
          });
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    showTeamListTable() {
      this.viewTeam = false;
      this.selectedTeam = null;
      this.teamMembers = null;
    },
    createTeam() {
      this.showCreateTeamModal = true;
    },
    hideCreateTeamModal() {
      this.showCreateTeamModal = false;
    },
    inviteMembersModal() {
      this.showCreateTeamModal = false;
      this.showInviteMembersModal = true;
    },
    showInvitationStatusModal(Invitations) {
      this.invitations = Invitations.data;
      this.showCreateTeamModal = false;
      this.showInviteMembersModal = false;
      this.showInvitationStatus = true;
    },
    hideInviteMembersModal() {
      this.TeamList();
      this.showInviteMembersModal = false;
    },
    hideInvitationStatus() {
      if (!this.viewTeam) {
        this.TeamList();
      } else {
        this.viewTeamMembers(this.selectedTeam);
      }
      this.showInvitationStatus = false;
    },
    handleResponsive() {
      this.isMobile = window.innerWidth < 1023;
    },
    updateQueryTab(tab) {
      this.viewTeam = false;
      if (tab === "teams") {
        this.TeamList();
      }
      this.tab = tab;
      this.$router.push({ path: "/profile", query: { tab: tab } });
    },
    toggleEdit() {
      this.isEditing = !this.isEditing;
      if (this.phone && this.phone !== "") {
        this.formattedphone();
      }
      if (this.phone && this.phone !== "") {
        this.matchCountryCode();
      }
    },
    checkChanges() {
      this.hasChanges =
        this.user !== this.originalUser ||
        this.phone !== this.originalPhone ||
        this.prevSelectedCountry !== this.selectedCountryCode ||
        (VueCookies.get("entityId") &&
          this.branchName !== this.originalBranchName);
    },
    async saveChanges() {
      const payload = {};
      if (this.user !== this.originalUser) {
        payload.name = this.user;
      }
      if (
        VueCookies.get("entityId") &&
        this.branchName !== this.originalBranchName
      ) {
        payload.entityBranch = this.branchName;
      }
      if (this.email) {
        payload.email = this.email;
      }
      if (
        this.phone !== this.originalPhone ||
        this.prevSelectedCountry !== this.selectedCountryCode
      ) {
        payload.phone =
          this.phone !== ""
            ? `+${this.selectedCountryCode.dialCode}-${this.phone}`
            : "";
        this.phoneWithCountryCode = payload.phone;
      }
      try {
        const response = await UpdateUserDetails(payload);
        if (response.message == "SUCCESS") {
          VueCookies.set("user", this.user);
          this.$root.userName = this.user;
          VueCookies.set("phone", this.phone);
          VueCookies.set("phone_w_countryCode", this.phoneWithCountryCode);
          if (VueCookies.get("entityId")) {
            VueCookies.set("branch", this.branchName);
            this.originalBranchName = this.branchName;
          }
          this.originalUser = this.user;
          this.originalPhone = this.phone;
          this.hasChanges = false;
          this.isEditing = false;
          // window.location.reload();
        } else {
          console.error("Something went wrong. Please try again later");
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          console.error("Error updating user details:", error);
        }
      }
    },
    confirmCancelEdit() {
      if (this.hasChanges) {
        if (confirm("You have unsaved changes. Do you want to save them?")) {
          this.saveChanges();
        } else {
          this.cancelEdit();
        }
      } else {
        this.cancelEdit();
      }
    },
    cancelEdit() {
      this.isEditing = false;
      this.user = this.originalUser;
      this.phone = this.originalPhone;
      if (VueCookies.get("entityId")) {
        this.branchName = this.originalBranchName;
      }
      this.hasChanges = false;
    },
    getFirstDialCode(dialCodeString) {
      return dialCodeString.split(",")[0];
    },
    async fetchCountryList() {
      try {
        const response = await AllCountries(false, false);
        this.countries = await response.allCountries;
      } catch (error) {
        this.loginError = "Error occurred during login.";
        console.error(error);
      }
    },
    matchCountryCode() {
      const parts = this.phoneWithCountryCode.split("-");
      let matchedCode = parts.slice(0, -1).join("-").replace("+", "");
      this.countries.map((country) =>
        country.dialCode.toString() === matchedCode.toString()
          ? (this.selectedCountryCode = country)
          : ""
      );
      this.prevSelectedCountry = this.selectedCountryCode;
    },
  },
};
</script>
<style scoped>
.dashboard,
.dashboard * {
  box-sizing: border-box;
}
.dashboard {
  /* background: linear-gradient(to left, #E0F5FF, #E0F5FF),
    linear-gradient(to left, #e7ebf0, #e7ebf0); */
  display: flex;
  flex-direction: column;
  /* margin-left: 18vw; */
  align-items: center;
  justify-content: flex-start;
  position: relative;
  /* margin-top: 104px; */
  height: 100%;
  /* overflow: hidden; */
}
.logged-in {
  margin-left: 18vw;
  padding-top: 55px;
  transition: margin-left 0.3s ease;
}
.logged-in.collapsed {
  margin-left: 60px;
}
.logged-in.notification {
  padding-top: 105px !important;
}
.not-logged-in {
  width: 100%;
}
.navbar-instance {
  background: #ffffff !important;
  flex-shrink: 0 !important;
  width: 1440px !important;
}
.frame-35705 {
  background: #e2eaf5;
  padding: 20px 40px 20px 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
}
.password-change {
  padding: 10px 20px;
  width: 100%;
  border: none;
  cursor: pointer;
  background-color: #224096;
}
.info {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  width: 100%;
}
.profile-info-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.poc-details {
  width: 40%;
  display: flex;
  padding-left: 30px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
  margin-left: 20px;
  border-left: 2px solid #3e485533;
  margin-top: 25px;
  align-self: stretch;
}
.poc-title {
  color: #224096;
  font-family: "Figtree";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.24px;
  text-align: left;
}
.poc-data {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  overflow-wrap: anywhere;
}
.label {
  color: #224096;
  font-family: "Figtree";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.2px;
}
.social-media-icons {
  width: 20px;
}
.tooltip-content-profile {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  /* padding: 8px; */
  width: 100%;
  gap: 8px;
}
.tooltip-message-profile {
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: #fff;
}
.referal-card {
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 16px;
  background: #224096;
}
.card-title-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}
.card-title {
  color: var(--Other-WHITE, #fff);
  font-family: "Figtree";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.2px;
}
.card-title-2 {
  color: var(--Other-WHITE, #fff);
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.16px;
  align-self: stretch;
}
.referal-code-box {
  display: flex;
  padding: 10px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 13px;
  background: #fff;
  position: relative;
}
.referal-code {
  color: var(--Text-Mid, #3e4855);
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.16px;
  width: 75%;
}
.no-teams {
  color: #224096;
  opacity: 0.6;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.16px;
}
.copy-code {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  right: 6px;
  top: 10px;
  cursor: pointer;
}
.invite-button {
  display: flex;
  padding: 10px 36px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 16px;
  background: #EFCC3A;
  color: #415648;
  text-align: center;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.16px;
  cursor: pointer;
}
.frame-357042 {
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
}
.welcome-to-credence {
  color: var(--secondary-grey-900, #2b3674);
  text-align: left;
  font-family: "Figtree";
  font-size: 24px;
  line-height: 42px;
  font-weight: 700;
  position: relative;
}
.frame-35732 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 2rem 3rem;
  background-color: #f2f8ff;
}
.frame-35733 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 30px;
  width: 100%;
}
.tab-1 {
  display: flex;
  min-width: 190px;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 16px 16px 0px 0px;
  background: #E0F5FF;
  color: var(--Dark-Blue, #224096);
  font-family: "Figtree";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.4px;
}
.frame-35734 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  min-height: 90%;
  padding: 20px;
  background: white;
  border-radius: 0px 16px 16px 16px;
  box-shadow: none !important;
  position: relative;
}
.frame-35735 {
  color: #224096;
  font-family: "Figtree";
  font-size: 28px;
  text-align: left;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.28px;
  /* width: 100%; */
  padding: 20px 0;
}
.frame-35735-1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-transform: capitalize;
  gap: 20px;
  color: #224096;
  font-family: "Figtree";
  font-size: 28px;
  text-align: left;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.28px;
  padding: 20px 0;
}
.frame-35736 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  padding: 15px 0;
  border-bottom: 2px solid #cccccc;
}
.frame-35737 {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 15px;
  overflow-wrap: anywhere;
}
.title {
  color: #224096;
  font-family: "Figtree";
  font-size: 20px;
  text-align: left;
  width: 100%;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.2px;
}
.value {
  color: #224096;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.16px;
  text-align: left;
  width: 100%;
}
.edit-button {
  color: #224096;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.16px;
  text-align: left;
  margin-right: 5vw;
}
.user-name-input {
  color: #224096 !important;
  text-align: center;
  font-family: "Figtree";
  font-size: 16px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  border-radius: 16px;
  border: 1px solid rgba(17, 54, 90, 0.4);
  outline: none;
  text-align: left;
  box-shadow: none;
  width: 100%;
  background-color: transparent;
  display: flex;
  width: 30vw;
  height: 3rem;
  align-items: center;
}
.frame-35738 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  position: relative;
  width: 30vw;
}
.save-button {
  display: flex;
  color: white;
  font-family: "Figtree";
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.16px;
  border-radius: 16px;
  padding: 12px 26px;
  justify-content: center;
  align-items: center;
  background: #224096;
  flex-shrink: 0;
  flex: 1;
  min-width: 160px;
  cursor: pointer;
}
.cancel-button {
  color: #224096;
  border: 2px solid #224096;
  font-family: "Figtree";
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.16px;
  border-radius: 16px;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-width: 160px;
  cursor: pointer;
}
.frame-357341 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-bottom: 2px solid #cccccc;
}
.frame-357351 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2vw;
  /* width: 45vw; */
}
.country-dropdown {
  width: 35%;
  color: #224096 !important;
  text-align: center;
  font-family: "Figtree";
  font-size: 16px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  border-radius: 16px;
  border: 1px solid rgba(17, 54, 90, 0.4);
  outline: none;
  text-align: left;
  box-shadow: none;
  background-color: transparent;
  display: flex;
  height: 3rem;
  align-items: center;
}
.input-group-phone {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: 30vw;
}
.phone-input {
  color: #224096 !important;
  text-align: center;
  font-family: "Figtree";
  font-size: 16px;
  line-height: 150%;
  font-weight: 400;
  position: relative;
  border-radius: 16px;
  border: 1px solid rgba(17, 54, 90, 0.4);
  outline: none;
  text-align: left;
  box-shadow: none;
  background-color: transparent;
  display: flex;
  width: 70%;
  height: 3rem;
  align-items: center;
  padding: 0px 20px;
}
.table-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 20px 0;
  border-bottom: 2px solid #cccccc;
}
#searchResultTable {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  font-family: "Figtree";
}
#searchResultTable th {
  text-align: left;
  font-family: "Figtree";
  color: #224096;
  padding: 10px 16px;
  min-width: 30px;
}
#searchResultTable td {
  text-align: left;
  padding: 10px 16px;
  color: #224096;
  font-size: 16px;
  font-weight: 400;
  line-height: 175%;
  letter-spacing: -0.16px;
}
.button-outer {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  width: 48px;
  background: white;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.18);
  cursor: pointer;
}
.view-team {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  text-align: left;
  font-family: "Figtree";
  color: #224096;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: -0.16px;
  cursor: pointer;
}
.button-border {
  border-radius: 50%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  width: 86%;
  height: 86%;
}
.action-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  gap: 20px;
}
.status-bg {
  padding: 4px 12px;
  border-radius: 8px;
  font-weight: 600;
}
.no-teams-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
  height: 50vh;
}
.loader-wrapper {
  top: 0;
  height: 100vh;
  width: 100vw;
  z-index: 1000;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 8%);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}
@media only screen and (max-width: 767px) {
  .frame-35732 {
        padding: 5rem 1rem;

  }
  .tab-1 {
    padding: 6px 12px;
    font-size: 16px;
    width: calc(100% / 3);
    min-width: auto;
    line-height: normal;
    align-self: stretch;
  }
  .frame-35734 {
    border-radius: 0px 0px 16px 16px;
  }
  .no-teams {
    font-size: 14px;
  }
  .frame-35735 {
    padding: 15px 0;
  }
  .frame-35735,
  .title,
  .poc-title,
  .label {
    font-size: 18px;
  }
  .info {
    flex-direction: column;
  }
  #searchResultDiv {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    align-self: stretch;
    width: 100%;
    gap: 20px;
  }
  .result-wrapper {
    display: flex;
    padding: 21.634px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;
    border-radius: 21.634px;
    border: 1.352px solid rgba(0, 0, 0, 0.15);
    background: #fff;
    margin-bottom: 20px;
  }
  .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    align-self: stretch;
    color: #224096;
    overflow-wrap: anywhere;
  }
  .label {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    align-self: stretch;
    color: #224096;
    font-family: "Figtree";
    text-align: left;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: -0.216px;
    width: 17vw;
    line-height: 27px;
  }
  .value {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    align-self: stretch;
    color: #224096;
    font-family: "Figtree";
    text-align: left;
    font-size: 16px;
    font-style: normal;
    letter-spacing: -0.216px;
    /* text-transform: capitalize; */
    flex: 1;
  }
  .poc-details {
    width: 100%;
    padding: 0;
    margin-left: 0;
    border-left: none;
    gap: 15px;
  }
  .cancel-button,
  .save-button {
    min-width: 80px;
    line-height: 8px;
    padding: 10px 10px;
    border-radius: 8px;
    font-size: 14px;
  }
  .save-button {
    padding: 12px 12px;
  }
  .frame-35737,
  .user-name-input,
  .input-group-phone {
    width: 100%;
    margin: 0;
    gap: 0.5rem;
  }
  .phone-input,
  .user-name-input,
  .country-dropdown {
    height: 2.5rem;
  }
  .card-title,
  .card-title-2 {
    text-align: left;
  }
  .referal-code-box,
  .invite-button {
    padding: 8px;
  }
  .profile-info-wrapper {
    width: 100% !important;
  }
  .frame-35733 {
    gap: 10px;
  }
  .team-icon {
    width: 25px;
    height: 25px;
  }
  #create-team-button {
    padding: 5px 8px;
  }
  #searchResultTable th,
  #searchResultTable td {
    padding: 10px;
    font-size: 14px;
  }
  .view-team {
    line-height: 20px;
    font-size: 14px;
  }
  .table-wrapper {
    margin: 20px 0 0 0;
  }
  .status-bg {
    padding: 0px 12px;
  }
  .frame-35735-1 {
    font-size: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1156px) {
}
@media only screen and (min-width: 1156px) {
}
</style>
